<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-truck"></i> 空间资源</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="80px"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="24">
          <!-- 空间下拉选项 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="空间名称">
              <el-select
                v-model="queryParams.spaceId"
                placeholder="请选择空间"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="space in spaceOptions"
                  :key="space.id"
                  :label="space.name"
                  :value="space.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="文件名称">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入文件名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
            >搜索</el-button
          >
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog"
            >上传</el-button
          >
        </el-row>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="文件名称" prop="name"></el-table-column>
        <el-table-column label="所属空间" prop="spaceName"></el-table-column>
        <el-table-column label="文件预览" prop="file">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.file"
              style="width: 50px; height: 50px"
              fit="cover"
              :preview-src-list="[scope.row.file]"
              v-if="scope.row.file"
            ></el-image>
            <span v-else>无预览图</span>
          </template>
        </el-table-column>
        <el-table-column label="文件格式" prop="fileType">
          <template #default="{ row }">
            {{ getFileType(row.file) }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime"></el-table-column>
        <el-table-column label="操作" width="200">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="mini"
              @click="openEditNameDialog(scope.row)"
              >编辑名称</el-button
            >
            <el-button
              size="mini"
              @click="deleteResource(scope.row)"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增弹窗 -->
      <el-dialog
        @close="resetForm"
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑资源' : '上传资源'"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="currentResource"
          ref="form"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="文件名称" prop="name">
            <el-input
              v-model="currentResource.name"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="所属空间" prop="spaceId">
            <el-select
              v-model="currentResource.spaceId"
              placeholder="请选择空间"
              style="width: 100%"
            >
              <el-option
                v-for="space in spaceOptions"
                :key="space.id"
                :label="space.name"
                :value="space.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="选择文件" prop="file">
            <el-upload
              ref="upload"
              :headers="uploadHeaders"
              :action="UPLOAD_URL"
              :auto-upload="true"
              :file-list="fileList"
              :limit="1"
              :on-exceed="handleExceed"
              :on-success="handleUploadSuccess"
              :accept="allowedFileTypes"
              :on-change="handleFileChange"
            >
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <div slot="tip" class="el-upload__tip" v-if="!isEdit">
                支持图片、视频、PPT、PDF、Word文件，图片不超过10M，视频不超过500M
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveResource">{{
            isEdit ? "更新" : "确定"
          }}</el-button>
        </span>
      </el-dialog>

      <!-- 编辑文件名称弹窗 -->
      <el-dialog
        :visible.sync="editNameDialogVisible"
        title="编辑文件名称"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="editResource"
          ref="editForm"
          :rules="editRules"
          label-width="100px"
        >
          <el-form-item label="文件名称" prop="name">
            <el-input
              v-model="editResource.name"
              placeholder="请输入文件名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editNameDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveResourceName">确定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  resourceList,
  spaceList,
  resourceAddOrEdit,
  resourceDelete,
} from "@/api/config";
import PaginationBar from "@/components/PaginationBar";
import { UPLOAD_URL } from "@/utils/const";
import { getToken } from "@/utils/auth";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      UPLOAD_URL,
      allowedFileTypes:
        "image/*,video/*,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      fileList: [], // 上传文件列表
      currentResource: {
        name: "",
        spaceId: "",
        file: null,
      },
      editResource: {
        id: "",
        name: "",
      },
      editRules: {
        name: [
          { required: true, message: "文件名称是必填项", trigger: "blur" },
        ],
      },
      rules: {
        name: [
          { required: true, message: "文件名称是必填项", trigger: "blur" },
        ],
        spaceId: [{ required: true, message: "请选择空间", trigger: "change" }],
        file: [
          { required: true, message: "请选择要上传的文件", trigger: "change" },
        ],
      },
      spaceOptions: [], // 空间选项
      queryParams: {
        name: "",
        spaceId: "", // 添加空间ID查询条件
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [1, 2, 3],
      dialogVisible: false,
      currentSupplier: {
        name: "",
        contactor: "",
        mobile: "",
      },
      isEdit: false,
      editNameDialogVisible: false,
    };
  },
  created() {
    this.getSpaceList(); // 获取空间列表
  },
  mounted() {
    // 组件挂载后处理路由参数
    this.processRouteParams();
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      if (to.path === '/config/supplier') {
        this.processRouteParams();
      }
    }
  },
  methods: {
    // 处理路由参数
    processRouteParams() {
      // 获取路由中的spaceName参数
      const spaceNameFromQuery = this.$route.query.spaceName;
      
      if (spaceNameFromQuery) {
        // 解码空间名称
        const decodedSpaceName = decodeURIComponent(spaceNameFromQuery);
        
        // 等待空间列表加载完成后设置默认选中项
        this.$nextTick(() => {
          this.setDefaultSpaceSelection(decodedSpaceName);
        });
      } else {
        // 如果没有spaceName参数，则执行常规查询
        this.handleQuery();
      }
    },
    
    // 设置默认空间选中项
    setDefaultSpaceSelection(spaceName) {
      // 查找匹配的空间选项
      const matchedSpace = this.spaceOptions.find(option => option.name === spaceName);
      
      if (matchedSpace) {
        // 设置选中的空间ID
        this.$set(this.queryParams, 'spaceId', matchedSpace.id);
        
        // 执行查询
        this.$nextTick(() => {
          this.handleQuery(1);
        });
      } else {
        // 如果未找到匹配的空间，仍然执行查询
        this.handleQuery(1);
      }
    },
    
    handleFileChange(file, fileList) {
      // 验证文件扩展名
      const fileExtension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (!this.allowedExtensions.includes(fileExtension)) {
        this.$message.error(
          "不支持的文件类型，请上传图片、视频、PPT、PDF或Word文档！"
        );
        // 清除文件列表
        this.$refs.upload.clearFiles();
        return false;
      }

      // 检查文件大小
      const fileSizeInMB = file.size / 1024 / 1024;

      // 判断是否为视频文件
      const isVideo =
        fileExtension === ".mp4" ||
        fileExtension === ".avi" ||
        fileExtension === ".mov" ||
        fileExtension === ".wmv" ||
        fileExtension === ".flv" ||
        fileExtension === ".mkv" ||
        fileExtension === ".mpeg" ||
        fileExtension === ".mpg";

      // 视频文件限制500MB，其他文件限制10MB
      if (isVideo && fileSizeInMB > 500) {
        this.$message.error("视频文件大小不能超过 500MB!");
        this.$refs.upload.clearFiles();
        return false;
      } else if (!isVideo && fileSizeInMB > 10) {
        this.$message.error("非视频文件大小不能超过 10MB!");
        this.$refs.upload.clearFiles();
        return false;
      }

      return true;
    },
    getFileType(url) {
      if (!url) return "";
      const parts = url.split(".");
      return parts.length > 1 ? parts.pop().toLowerCase() : "";
    },

    // 保存文件名称
    saveResourceName() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          resourceAddOrEdit(this.editResource).then(() => {
            this.editNameDialogVisible = false;
            this.handleQuery();
            this.$message.success("文件名称修改成功");
          });
        } else {
          return false;
        }
      });
    },
    // 打开编辑文件名称弹窗
    openEditNameDialog(row) {
      this.editResource = {
        id: row.id,
        name: row.name,
        spaceId: row.spaceId,
        file: row.file,
      };
      this.editNameDialogVisible = true;
    },
    // 保存资源
    saveResource() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 调用上传资源接口
          resourceAddOrEdit(this.currentResource).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },
    // 文件超出限制时的处理
    handleExceed() {
      this.$message.warning("只能上传一个文件");
    },
    // 添加上传成功处理函数
    handleUploadSuccess(response, file, fileList) {
      console.log("上传成功", response, file, fileList);
      // 根据实际API返回结构处理文件URL
      if (response && response.data) {
        this.currentResource.file = response.data; // 假设返回的文件URL在response.data中
      }
    },

    // 获取空间列表
    getSpaceList() {
      spaceList({
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        this.spaceOptions = res.records || [];
        
        // 空间数据加载完成后，如果有路由参数需要处理，则再次处理
        if (this.$route.query.spaceName) {
          this.processRouteParams();
        }
      });
    },
    // 重置表单
    resetForm() {
      this.currentResource = {
        name: "",
        spaceId: "",
        file: null,
      };
      this.fileList = [];
      // 重置表单及校验状态
      this.$refs.form.resetFields();
    },
    handleQuery(page) {
      const { name, spaceId } = this.queryParams;
      this.currentPage = page || 1;
      resourceList({
        name,
        spaceId, // 添加空间ID查询参数
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        name: "",
        spaceId: "",
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.isEdit = false;
      this.currentResource = {
        name: "",
        spaceId: "",
        file: null,
      };
      this.fileList = [];
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      this.currentSupplier = { ...row };
      this.dialogVisible = true;
    },
    saveSupplier() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {};
          params = { ...this.currentSupplier };
          if (this.isEdit) {
            params.id = this.currentSupplier.id; // 编辑时传 id
          }
          // 如果你需要调用接口，就取消下面这行注释
          resourceAddOrEdit(params).then(() => {
            this.dialogVisible = false;
            this.handleQuery();
            this.$message.success("操作成功");
          });
        } else {
          return false;
        }
      });
    },
    deleteResource(row) {
      this.$confirm("确定删除当前资源？", "删除提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          resourceDelete({ id: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          });
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>
